import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Html } from "../../../Shared/backendApi/Text";
import { Notice } from "../../../Shared/components/Notice";
import { errorText, getActivityEditions, getDatesForPeriod, loadingText } from "../../custom_api/api";
import { emptyOpt, makeOpt } from "../../custom_utils/option";
import { ActivityEditionList } from "../components/activity_edition_list";
import { BlockRenderer } from "../components/block_renderer";
import { Jumbo } from "../components/jumbo";
import { Block } from "../components/library/container";
import { RegionAndDateFilter } from "../components/region_and_date_filter";
import { SearchBarWrapper } from "../components/search_bar";
const activityDetailPageStateZero = {
    editions: "loading"
};
export class ActivityDetailPage extends React.Component {
    componentDidMount() {
        const p = this.props;
        const s = this.state;
        if (s.editions == "loading") {
            getActivityEditions({
                cluster: emptyOpt(),
                activity: makeOpt((q)=>q.Where((a)=>a.Id.Equals(p.activityId).And(a.HideInOverview.Equals(false)))),
                edition: emptyOpt(),
                region: makeOpt((q)=>p.selectedRegion ? q.Where((r)=>r.Slug.Equals(p.selectedRegion)) : q),
                location: emptyOpt(),
                event: makeOpt((q)=>q.Where((e)=>{
                        let period = getDatesForPeriod(p.selectedPeriod);
                        return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()));
                    }))
            }).then((x)=>this.setState((s)=>({
                        ...s,
                        editions: x
                    })));
        }
    }
    componentWillReceiveProps(nextProps) {
        const p = this.props;
        const np = nextProps;
        if (p.selectedPeriod == np.selectedPeriod && p.selectedRegion == np.selectedRegion) return;
        this.setState((s, _)=>({
                ...s,
                clusters: "loading"
            }), ()=>{
            getActivityEditions({
                cluster: emptyOpt(),
                activity: makeOpt((q)=>q.Where((a)=>a.Id.Equals(np.activityId).And(a.HideInOverview.Equals(false)))),
                edition: emptyOpt(),
                region: makeOpt((q)=>np.selectedRegion ? q.Where((r)=>r.Slug.Equals(np.selectedRegion)) : q),
                location: emptyOpt(),
                event: makeOpt((q)=>q.Where((e)=>{
                        let period = getDatesForPeriod(np.selectedPeriod);
                        return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()));
                    }))
            }).then((x)=>this.setState((s)=>({
                        ...s,
                        editions: x
                    })));
        });
    }
    render() {
        const p = this.props;
        const s = this.state;
        const editionsList = /*#__PURE__*/ _jsx("div", {
            className: "container--mg align--center",
            "aria-live": "polite",
            children: s.editions == "loading" ? /*#__PURE__*/ _jsx("div", {
                className: "text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: loadingText
                })
            }) : s.editions == "error" ? /*#__PURE__*/ _jsx("div", {
                className: "text--styled",
                children: /*#__PURE__*/ _jsx("p", {
                    className: "weight--bold container--s",
                    children: errorText
                })
            }) : /*#__PURE__*/ _jsx(ActivityEditionList, {
                editions: s.editions
            })
        });
        const filter = /*#__PURE__*/ _jsx(SearchBarWrapper, {
            children: /*#__PURE__*/ _jsx(RegionAndDateFilter, {
                enabled: s.editions != "loading" && s.editions != "error",
                selectedPeriod: p.selectedPeriod,
                selectedRegion: p.selectedRegion,
                selectPeriod: p.selectPeriod,
                selectRegion: p.selectRegion,
                regions: p.regions
            })
        });
        return /*#__PURE__*/ _jsxs("div", {
            className: "page--activity",
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: p.headerTitle,
                    contents: p.description,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    size: "small",
                    kind: "activity"
                }),
                s.editions != "loading" && s.editions != "error" ? /*#__PURE__*/ _jsx(_Fragment, {}) : filter,
                /*#__PURE__*/ _jsx(Block, {
                    children: editionsList
                }),
                /*#__PURE__*/ _jsx("hr", {}),
                /*#__PURE__*/ _jsxs(Block, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "container--mg align--center",
                            children: /*#__PURE__*/ _jsx(Notice, {
                                title: p.noticeTitle,
                                description: Html(p.noticeContents)
                            })
                        }),
                        /*#__PURE__*/ _jsx("hr", {}),
                        /*#__PURE__*/ _jsx(BlockRenderer, {
                            blocks: p.blocks
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = activityDetailPageStateZero;
        document.title = this.props.pageTitle;
    }
}
{}